export const TRAILERS = "TRAILERS";
export const EQUIPMENTS = "EQUIPMENTS";
export const EQUIPMENTS_COUNT = "EQUIPMENTS_COUNT";
export const SELCTED_EQUIPMENT = "SELCTED_EQUIPMENT";
export const APP_EQUIPMENT_BUSY = "APP_EQUIPMENT_BUSY";
export const EQUIPMENTS_PAGINATION = "EQUIPMENTS_PAGINATION";
export const EQUIPMENTS_ASSET_TYPE = "EQUIPMENTS_ASSET_TYPE";
